import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, FileInput, HelpLink, Text } from '../../../../components/common';
import { BiAddMediaActionTarget, BiAddMediaClickOrigin } from '../../../../constants/Bi';
import { HELP_LINKS } from '../../../../constants/HelpLinks';
import { useTrackAddMediaMediaSourceSelected } from '../../../../utils/hooks/bi/useTrackAddMediaMediaSourceSelected';
import styles from './ComputerImporter.scss';
import { IOuter } from './ComputerImporter.types';
import { FedOpsInteraction } from '../../../../constants/FedOpsInteraction';
import { fedopsLogger } from '../../../../services/loggers/fedopsLogger';

export const ComputerImporter: FC<IOuter> = ({ onSelect }) => {
  const handleFiles = useCallback((files, _folder, options) => onSelect(files, options), [onSelect]);

  const { trackAddMediaMediaSourceSelectedUploadWidget } = useTrackAddMediaMediaSourceSelected();

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerAndCTA}>
        <Text className={styles.header} weight="normal" size="medium">
          <FormattedMessage id="files-importer.drag-drop-files-here" />
        </Text>

        <Text className={styles.or} weight="thin" size="medium" secondary>
          <FormattedMessage id="files-importer.drag-drop-files-here-or" />
        </Text>

        <FileInput
          onFiles={handleFiles}
          biOrigin={BiAddMediaClickOrigin.ImportFilesTabs}
          biTarget={BiAddMediaActionTarget.Upload}
        >
          {({ openFilesInput }) => (
            <Button
              className={styles.cta}
              onClick={(event) => {
                trackAddMediaMediaSourceSelectedUploadWidget(BiAddMediaActionTarget.Upload);
                fedopsLogger.interactionStarted(FedOpsInteraction.OpenUploadDialog);
                openFilesInput(event);
              }}
            >
              <FormattedMessage id="files-importer.upload-from-computer" />
            </Button>
          )}
        </FileInput>
      </div>

      <Text className={styles.footer} weight="thin" size="small" secondary>
        <FormattedMessage
          id="files-importer.import-by-url-supported-file-types"
          values={{
            readMoreLink: (
              <HelpLink article={HELP_LINKS.LEARN_MORE_SUPPORTED_TYPES_AND_SIZES} size="small">
                <FormattedMessage id="files-importer.read-more" />
              </HelpLink>
            ),
          }}
        />
      </Text>
    </div>
  );
};
